import { all, put, takeEvery } from 'redux-saga/effects';
import {
  change, doSubmit, startSubmit, stopSubmit, reset,
} from 'circe/forms/actions';
import { exception } from 'circe/logger';
import { authClient, operatorClient } from 'domain/HttpClients';
import { doPut } from 'circe/Http/saga';

import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { FORM_NAME } from './constants';

function* doUpdate(context, action) {
  if (action.payload.name !== FORM_NAME) return;
  yield put(startSubmit(FORM_NAME));
  try {
    const {
      payload: { values },
    } = action;

    const {
      firstName, lastName, phone, email, username, profileId, userId,
    } = values;

    try {
      const response = yield authClient
        .Post(`/public-api/user-admin/${userId}/update-info`)
        .withData({
          domain: `${SYSTEM_DOMAIN}`,
          userInfo: {
            firstName,
            lastName,
            phone,
            email,
            preferredUsername: email,
          },
        })
        .send();
    } catch (e) {
      throw new Error(e.message);
    }

    const response = yield updateUserInfo(
      profileId,
      userId,
      email,
      phone,
      firstName,
      lastName,
      username,
    );

    window.store.dispatch(
      showNotification(
        I18n.str('userInfoUpdateSuccess', 'User Info Updated Successfully'),
        'success',
      ),
    );

    context.history.push('/users');
  } catch (e) {
    window.store.dispatch(
      showNotification(I18n.str('error', 'Something Went Wrong, Please try again'), 'error'),
    );
    console.error(e);
    exception(e);
  } finally {
    yield put(stopSubmit(FORM_NAME));
  }
}

function* updateUserInfo(profileId, userId, email, phone, firstName, lastName) {
  try {
    const response = yield operatorClient
      .Put('/api/users')
      .withData({
        profileId,
        userId,
        email,
        phone,
        firstName,
        lastName,
      })
      .send();
  } catch (e) {
    throw new Error(e.message);
  }
}
function* watcher(context) {
  yield all([takeEvery(doSubmit().type, doUpdate, context)]);
}

export default watcher;
